import { Box, Container } from '@theme-ui/components'
import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router'
import { createUser } from '../../api/users'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import { notifyErrorAPI, notifySuccess } from '../../components/Notif'
import UserForm, { UserFormValues } from './components/UserForm'

export default function CreateUserPage() {
  const navigate = useNavigate()
  const createM = useMutation(
    (data: { user: { email; fname; lname; password; roleIds } }) => {
      return createUser(data)
    },
    {
      onSuccess: () => {
        notifySuccess('User berhasil dibuat')
        navigate('/users')
      },
      onError: notifyErrorAPI,
    }
  )

  function handleSubmit(values: UserFormValues) {
    createM.mutate({
      user: {
        email: values.email,
        fname: values.fname,
        lname: values.lname,
        roleIds: values.role_ids,
        password: values.password,
      },
    })
  }
  return (
    <Container px={4} py={3}>
      <Box sx={{ mb: 3 }}>
        <Breadcrumb
          crumbs={[
            { label: 'Home', link: '/' },
            { label: 'Users', link: '/users' },
            { label: 'Create', link: '/users/create' },
          ]}
        />
      </Box>

      <UserForm
        initialValues={{
          email: '',
          password: '',
          role_ids: [],
          fname: '',
          lname: '',
        }}
        onSubmit={handleSubmit}
      />
    </Container>
  )
}
